import { DoorConfiguration } from '../../configurator/DoorConfiguration';
import { mainNavigationItems as navigation } from '../../configurator/MainNavigation';
import characteristicsService from '../../services/Configurator/CharacteristicsService';
import StoreEngine from '../../configurator/StoreEngine';
import store from '@/store/index';
import {parseToGermanFloat, parseFloatFromGermanFloat} from '../../services/ParserService';

const getDefaultState = () => {
    return {
      productId: 0,
      chargeId: 0,
      mainNavActiveId: 0,
      subNavActiveId: {
        mainNavActiveId: 0,
        subNavActiveId: 0,
      },
      doorConfiguration: DoorConfiguration.Instance,
      mainNavigation: navigation,
      allInitialCharacteristicsAndValues: [],
      ConfiguratorState: {
        ArticleNumber: "",
      },
      filteredCharacteristics: {
        selectedCharacteristicValues: "",
        selectedCharacteristics: new Array(),
      },
      blankCharacteristic: {
        id: 0,
        code: "NO_CODE",
        description: "Select Characteristic",
        value: {
          id: 0,
          value: "0",
          description: "Select Value",
        },
      },

      noCharacteristic: {
        id: 0,
        code: "NO_CODE",
        description: "Select Characteristic",
        value: {
          id: 0,
          value: "0",
          description: "NEIN",
        },
      },
      functionsItems: [
        {
          displayText: "auswahlAufgehrichtung",
          code: 1,
          required: true,
          completed: () => {
            let status: boolean = false;
            const filteredObj = DoorConfiguration.Instance.Get(2)?.filter(
              (z: any) => z.code === "KTU_MM_AUFGEHRICHTUNG"
            )[0];
            status = typeof filteredObj !== "undefined" ? true : false;
            return status;
          },
        },
        {
          displayText: "auswahlMauerwerk",
          code: 2,
          required: true,
          completed: () => {
            let status: boolean = false;

            const filteredObj1 = DoorConfiguration.Instance.Get(2)?.filter(
              (z: any) => z.code === "KTU_MM_WANDART_BESTAND"
            )[0];

            const filteredObj2 = DoorConfiguration.Instance.Get(2)?.filter(
              (z: any) => z.code === "KTU_MM_WANDDICKE"
            )[0];

            const filteredObj3 = DoorConfiguration.Instance.Get(2)?.filter(
              (z: any) => z.code === "CUST_MM_MINDESTBESTANDSSTARKE"
            )[0];

            status =
              typeof filteredObj1 !== "undefined" &&
              typeof filteredObj2 !== "undefined" &&
              filteredObj2.value.value !== "0" &&
              filteredObj2.value.value !== "" &&
              filteredObj2.value.value >=
                parseInt(filteredObj3.value.description)
                ? true
                : false;
            return status;
          },
        },
        {
          displayText: "zusatzdichtung",
          code: 3,
          required: false,
          completed: () => {
            let status: boolean = false;

            const filteredObj = DoorConfiguration.Instance.Get(2)?.filter(
              (z: any) => z.code === "CUST_MM_RH_DICHTUNG"
            )[0];
            status = typeof filteredObj !== "undefined" ? true : false;
            return status;
          },
        },
        {
          displayText: "zierleisten",
          code: 4,
          required: false,
          completed: () => {
            let status: boolean = false;

            const filteredObj1 = DoorConfiguration.Instance.Get(2)?.filter(
              (z: any) => z.code === "KTU_MM_ZIERLEISTENART"
            )[0];

            const filteredObj2 = DoorConfiguration.Instance.Get(2)?.filter(
              (z: any) => z.code === "KTU_MM_ZIERLEISTENVAR_BS"
            )[0];

            const filteredObj3 = DoorConfiguration.Instance.Get(2)?.filter(
              (z: any) => z.code === "KTU_MM_ZIERLEISTENVAR_GBS"
            )[0];

            const filteredObj4 = DoorConfiguration.Instance.Get(2)?.filter(
              (z: any) => z.code === "KTU_MM_ZIERLEISTENVAR_O_BS"
            )[0];

            const filteredObj5 = DoorConfiguration.Instance.Get(2)?.filter(
              (z: any) => z.code === "KTU_MM_ZIERLEISTENVAR_O_GBS"
            )[0];
            status =
              typeof filteredObj1 !== "undefined" &&
              typeof filteredObj2 !== "undefined" &&
              typeof filteredObj3 !== "undefined" &&
              typeof filteredObj4 !== "undefined" &&
              typeof filteredObj5 !== "undefined"
                ? true
                : false;
            return status;
          },
        },
        {
          displayText: "lichtausschnitt",
          code: 5,
          required: false,
          completed: () => {
            let status: boolean = false;

            const filteredObj1 = DoorConfiguration.Instance.Get(2)?.filter(
              (z: any) => z.code === "KTU_MM_GLASART"
            )[0];

            const filteredObj2 = DoorConfiguration.Instance.Get(2)?.filter(
              (z: any) => z.code === "KTU_MM_GLASVARIANTE"
            )[0];

            const filteredObj3 = DoorConfiguration.Instance.Get(2)?.filter(
              (z: any) => z.code === "KTU_MM_GLASVARIANTE_O"
            )[0];
            status =
              typeof filteredObj1 !== "undefined" &&
              typeof filteredObj2 !== "undefined" &&
              typeof filteredObj3 !== "undefined"
                ? true
                : false;
            return status;
          },
        },
        {
          displayText: "schlagleisten",
          code: 7,
          required: false,
          completed: () => {
            let status: boolean = false;

            const filteredObj1 = DoorConfiguration.Instance.Get(2)?.filter(
              (z: any) => z.code === "KTU_MM_SCHLAGL_ANZ_BS"
            )[0];

            const filteredObj2 = DoorConfiguration.Instance.Get(2)?.filter(
              (z: any) => z.code === "KTU_MM_SCHLAGL_ANZ_GBS"
            )[0];

            const filteredObj3 = DoorConfiguration.Instance.Get(2)?.filter(
              (z: any) => z.code === "CUST_MM_SCHLAGL_ANZ_W_BS"
            )[0];

            const filteredObj4 = DoorConfiguration.Instance.Get(2)?.filter(
              (z: any) => z.code === "CUST_MM_SCHLAGL_ANZ_W_GBS"
            )[0];
            status =
              typeof filteredObj1 !== "undefined" &&
              typeof filteredObj2 !== "undefined" &&
              typeof filteredObj3 !== "undefined" &&
              typeof filteredObj4 !== "undefined"
                ? true
                : false;
            return status;
          },
        },
        {
          displayText: "schallschutzSonder",
          code: 8,
          required: false,
          completed: () => {
            let status: boolean = false;

            const filteredObj = DoorConfiguration.Instance.Get(2)?.filter(
              (z: any) => z.code === "KTU_MM_SCHALLSCHUTZ_PLUS"
            )[0];
            status = typeof filteredObj !== "undefined" ? true : false;
            return status;
          },
        },
        {
          displayText: "beschusshemmung",
          code: 9,
          required: false,
          completed: () => {
            let status: boolean = false;

            const filteredObj = DoorConfiguration.Instance.Get(2)?.filter(
              (z: any) => z.code === "KTU_MM_FUNKTION_BESCHUSS"
            )[0];
            status = typeof filteredObj !== "undefined" ? true : false;
            return status;
          },
        },
        // {
        //   displayText: "panikturEN1125",
        //   code: 10,
        //   required: false,
        //   completed: () => {
        //     let status: boolean = false;
        //
        //     const filteredObj = DoorConfiguration.Instance.Get(2)?.filter(
        //       (z: any) => z.code === "KTU_MM_FUNKTION_EN1125"
        //     )[0];
        //     status = typeof filteredObj !== "undefined" ? true : false;
        //     return status;
        //   },
        // },
        // {
        //   displayText: "fluchtturEN179",
        //   code: 11,
        //   required: false,
        //   completed: () => {
        //     let status: boolean = false;
        //
        //     const filteredObj = DoorConfiguration.Instance.Get(2)?.filter(
        //       (z: any) => z.code === "KTU_MM_FUNKTION_EN179"
        //     )[0];
        //     status = typeof filteredObj !== "undefined" ? true : false;
        //     return status;
        //   },
        // },
      ],
      frameItems: [
        {
          displayText: "zarge",
          code: 1,
          required: true,
          completed: () => {
            let status = false;

            const filteredObj = DoorConfiguration.Instance.Get(3)?.filter(
              (z: any) => z.code === "KTU_MM_ZARGEN_KURZFORM"
            )[0];
            status = typeof filteredObj !== "undefined" ? true : false;
            return status;
          },
        },
      ],
      measureItems: [
        {
          displayText: "auswahl",
          code: 1,
          required: true,
          completed: () => {
            let status = false;

            const filteredObj = DoorConfiguration.Instance.Get(4)?.filter(
              (z: any) => z.code === "CUST_MM_TUERMASS"
            )[0];
            let filteredObj1 = false;
            let filteredObj2 = false;
            let filteredObj3 = false;
            let f1 = [];
            let f2 = [];
            let f3 = [];

            if (typeof filteredObj !== "undefined") {
              const filteredObjVal = filteredObj.value.value;
              if (filteredObjVal === "FF") {
                f1 = DoorConfiguration.Instance.Get(4)?.filter(
                  (z: any) => z.code === "KTU_MM_STLB"
                )[0];
                f2 = DoorConfiguration.Instance.Get(4)?.filter(
                  (z: any) => z.code === "KTU_MM_BSTLH"
                )[0];
                f3 = DoorConfiguration.Instance.Get(4)?.filter(
                  (z: any) => z.code === "KTU_MM_GBSTLH"
                )[0];
              } else {
                f1 = DoorConfiguration.Instance.Get(4)?.filter(
                  (z: any) => z.code === "KTU_MM_MLB"
                )[0];
                f2 = DoorConfiguration.Instance.Get(4)?.filter(
                  (z: any) => z.code === "KTU_MM_BMLH"
                )[0];
                f3 = DoorConfiguration.Instance.Get(4)?.filter(
                  (z: any) => z.code === "KTU_MM_GBMLH"
                )[0];
              }

              filteredObj1 =
                typeof f1 !== "undefined" && parseInt(f1.value.value) > 0;
              filteredObj2 =
                typeof f2 !== "undefined" && parseInt(f2.value.value) > 0;
              filteredObj3 =
                typeof f3 !== "undefined" && parseInt(f3.value.value) > 0;
            }

            status =
              typeof filteredObj !== "undefined" &&
              filteredObj1 &&
              filteredObj2 &&
              filteredObj3
                ? true
                : false;
            return status;
          },
        },
        {
          displayText: "oberblende",
          code: 2,
          required: true,
          completed: () => {
            const filteredObj = DoorConfiguration.Instance.Get(4)?.filter(
              (z: any) => z.code === "KTU_MM_DGLH_O"
            )[0];
            const filteredObjVal =
              typeof filteredObj !== "undefined"
                ? parseInt(filteredObj.value.value)
                : 0;
            const filteredObj1 = DoorConfiguration.Instance.GetHasTopPannel();
            let filteredObjIsOk: boolean = false;

            if (filteredObj1) filteredObjIsOk = filteredObjVal > 0;
            else filteredObjIsOk = true;

            return filteredObjIsOk;
          },
        },
        {
          displayText: "bodenanschlusse",
          code: 3,
          required: true,
          completed: () => {
            let status: boolean = false;
            const validCharacteristicsForInput = ["VS", "BS"];
            const filteredObj = DoorConfiguration.Instance.Get(4)?.filter(
              (z: any) => z.code === "CUST_MM_STAFFEL_FORM"
            )[0];
            const filteredObj1 = DoorConfiguration.Instance.Get(4)?.filter(
                (z: any) => z.code === "CUST_MM_STAFFEL_FORM"
            )[0];
            const inputIsShown: boolean =
              typeof filteredObj !== "undefined" &&
              validCharacteristicsForInput.includes(filteredObj.value.value);

            if (inputIsShown){
              let threshold: any = store.getters['measureModule/getThreshold'];
              let heightValue = filteredObj1.value.value === 'VS' ? threshold.HeightValueVS : filteredObj1.value.value === 'BS' ? threshold.HeightValueBS : 0;
              status =
                typeof heightValue !== "undefined" &&
                parseInt(heightValue) > 0;
            }
            else status = true;

            return status;
          },
        },
        {
          displayText: "gehUndStehflugel",
          code: 4,
          required: true,
          completed: () => {
            let status: boolean = false;
            const filteredObj = DoorConfiguration.Instance.Get(4)?.filter(
              (z: any) => z.code === "CUST_MM_TUER_MASS_SYM"
            )[0];
            const filteredObj1 = DoorConfiguration.Instance.Get(4)?.filter(
              (z: any) => z.code === "KTU_MM_DGLB_90_GEHFLUEGEL"
            )[0];
            const isAsymetric: boolean =
              typeof filteredObj !== "undefined" &&
              filteredObj.value.value === "ASY";

            if (isAsymetric)
              status =
                typeof filteredObj1 !== "undefined" &&
                parseInt(filteredObj1.value.value) > 0;
            else status = true;

            return status;
          },
        },
        {
          displayText: "turblattKurzung",
          code: 5,
          required: false,
          completed: () => {
            return false;
          },
        },
      ],
      doorSurfaceItems: [
        {
          displayText: "turblatt",
          code: 1,
          success: false,
          warning: false,
          required: false,
          completed: () => {
            return false;
          },
        },
        {
          displayText: "zarge",
          code: 2,
          success: false,
          warning: false,
          required: false,
          completed: () => {
            return false;
          },
        },
        {
          displayText: "bodenanschluss",
          code: 3,
          success: false,
          warning: false,
          required: true,
          completed: () => {
            let status: boolean = false;
            const filteredObj = DoorConfiguration.Instance.Get(4)?.filter(
              (z: any) => z.code === "CUST_MM_STAFFEL_FORM"
            )[0];
            let staffelCode = "";
            if (typeof filteredObj !== "undefined") {
              if (filteredObj.value.value === "STD")
                staffelCode = "CUST_MM_STAFFEL_OBERFLAECHE";
              else if (filteredObj.value.value === "HS")
                staffelCode = "CUST_MM_STAFFEL_FORM_OBF";
              else staffelCode = "KTU_MM_STAFFEL_OBERFLAECHE";
            }

            const filteredObj1 = DoorConfiguration.Instance.Get(5)?.filter(
              (z: any) => z.code === staffelCode
            )[0];

            status = typeof filteredObj1 !== "undefined";
            return status;
          },
        },
      ],
      exteriorAcessoriesItems: [
        {
          displayText: "sichtbeschlag",
          code: 1,
          required: false,
          completed: () => {
            return false;
          },
        },
        {
            displayText: "zylinder",
            code: 2,
            required: false,
            completed: () => {
                return false;
            },
        },
        {
            displayText: "zusatze",
            code: 3,
            required: true,
            completed: () => {
                //configure variables
                let status: boolean = false;
                const filteredObj = DoorConfiguration.Instance.Get(6)?.filter(
                  (z: any) => z.code === "KTU_MM_GITTER1"
                )[0];
                const filteredObj1 = DoorConfiguration.Instance.Get(6)?.filter(
                  (z: any) => z.code === "KTU_MM_GITTER2"
                )[0];
                const filteredObj3 = DoorConfiguration.Instance.Get(6)?.filter(
                  (z: any) => z.code === "KTU_MM_GITTER1_ANZ"
                )[0];
                const filteredObj4 = DoorConfiguration.Instance.Get(6)?.filter(
                  (z: any) => z.code === "KTU_MM_GITTER2_ANZ"
                )[0];
                const filteredObj5 = DoorConfiguration.Instance.Get(6)?.filter(
                    (z: any) => z.code === "KTU_MM_TRANSPONDER_ANZ"
                )[0];
                const filteredObj6 = DoorConfiguration.Instance.Get(6)?.filter(
                    (z: any) => z.code === "KTU_MM_KABELKANAL_ANZ"
                )[0];
                const filteredObj7 = DoorConfiguration.Instance.Get(6)?.filter(
                    (z: any) => z.code === "KTU_MM_REEDKONTAKT_ANZ"
                )[0];
                const filteredObj8 = DoorConfiguration.Instance.Get(6)?.filter(
                    (z: any) => z.code === "KTU_MM_TRANSPONDER_SET"
                )[0];
                const filteredObj9 = DoorConfiguration.Instance.Get(6)?.filter(
                    (z: any) => z.code === "KTU_MM_FUNK_SET"
                )[0];
                const filteredObj10 = DoorConfiguration.Instance.Get(6)?.filter(
                    (z: any) => z.code === "KTU_MM_FUNK_ANZ"
                )[0];
                const filteredObj11 = DoorConfiguration.Instance.Get(6)?.filter(
                    (z: any) => z.code === "CUST_MM_KABELKANALUEBERGANG"
                )[0];
                const filteredObj12 = DoorConfiguration.Instance.Get(6)?.filter(
                    (z: any) => z.code === "KTU_MM_REEDKONTAKT"
                )[0];
                const getTransponderControlsStatus = store.getters['exteriorAccessoryModule/getTransponderControlsStatus'];
                
                let filteredObj3IsValid: boolean = false;
                let filteredObj4IsValid: boolean = false;
                let filteredObj5IsValid: boolean = true;
                let filteredObj10IsValid: boolean = true;
                let filteredObj11IsValid: boolean = false;
                let filteredObj12IsValid: boolean = false;

                //Logic
                if (typeof filteredObj !== 'undefined' && filteredObj.value.value !== "NEIN")
                    filteredObj3IsValid = typeof filteredObj3 !== 'undefined' && parseInt(filteredObj3.value.value) > 0;
                else
                    filteredObj3IsValid = true;
                
                if (typeof filteredObj1 !== "undefined" && filteredObj1.value.value !== "NEIN")
                    filteredObj4IsValid = typeof filteredObj4 !== "undefined" && parseInt(filteredObj4.value.value) > 0;
                else filteredObj4IsValid = true;
                
                // if (getTransponderControlsStatus === false) {
                //     if (typeof filteredObj8 !== 'undefined' && filteredObj8.value.value.startsWith('LLT')) {
                //         filteredObj5IsValid = typeof filteredObj5 !== 'undefined' && parseInt(filteredObj5.value.value) > 0
                //         filteredObj10IsValid = true
                //     } else if (typeof filteredObj9 !== 'undefined' && filteredObj9.value.value.startsWith('LLT')) {
                //         filteredObj5IsValid = true;
                //         filteredObj10IsValid = typeof filteredObj10 !== 'undefined' && parseInt(filteredObj10.value.value) > 0
                //     } else {
                //         filteredObj5IsValid = true;
                //         filteredObj10IsValid = true
                //     }
                // }
                // else {
                //     filteredObj5IsValid = true;
                //     filteredObj10IsValid = true
                // }

                if (typeof filteredObj11 != 'undefined' && parseInt(filteredObj11.value.value) === 1)
                    filteredObj11IsValid = true;
                else
                    filteredObj11IsValid = (typeof filteredObj6 !== 'undefined' && parseInt(filteredObj6.value.value) > 0)

                if (typeof filteredObj12 != 'undefined' && parseInt(filteredObj12.value.value) === 0)
                    filteredObj12IsValid = true;
                else
                    filteredObj12IsValid = (typeof filteredObj7 !== 'undefined' && parseInt(filteredObj7.value.value) > 0)
                
                return filteredObj3IsValid
                    && filteredObj4IsValid
                    && filteredObj5IsValid
                    && filteredObj10IsValid
                    && filteredObj11IsValid
                    && filteredObj12IsValid;
            },
        },
      ],
      mountingMaterialItems: [
        {
          displayText: "artDesMaterials",
          completed: () => {
            return false;
          },
        },
      ],
      blindstockItems: [
        {
          displayText: "wertheimBlindstockMultiplex",
          completed: () => {
            return false;
          },
        },
        {
          displayText: "blindstockMountingMaterial",
          completed: () => {
            return false;
          },
        },
      ],
      furtherInformationItems: [
        {
          displayText: "zusatzinformationenBitteEintragen",
          completed: () => {
            return false;
          },
        },
      ],
    };
};

const state = getDefaultState();

const getters = {
    getCurrentDoorConfiguration: (s: any) => s.doorConfiguration,
    getMainNavActiveId(state: any) {
        return state.mainNavActiveId;
    },
    getSubNavActiveId(state: any) {
        return state.subNavActiveId;
    },
    getMainNav(state: any) {
        return state.mainNavigation;
    },
    getProductId(state: any) {
      return state.productId; 
    },
    getChargeId(state: any) {
      return state.chargeId;
    },
    getCurrentDoorModel: (s: any) => {
        return s.doorConfiguration.GetCurrentDoorModel;
    },
    getCurrentDoorMainFunction: (s: any) => {
        return s.doorConfiguration.GetCurrentDoorMainFunction;
    },
    getConfiguratorState: (s: any) => {
        return s.ConfiguratorState;
    },
    getFilteredCharacteristics: (s: any) => {
        return s.filteredCharacteristics;
    },
    getContextRegisteredCharacteristics: (s: any) => {
        return (configurationContext: number) => s.doorConfiguration.Get(configurationContext);
    },
    getRegisteredCharacteristicsValue: (s: any) => {
        return (charcteristicCode: string, configurationContext: number) =>
            returnRegisteredCharacteristicObject(charcteristicCode, configurationContext, s);
    },
    getFuncItems: (s: any) => {
      return s.functionsItems;
    },
    getFuncItem: (s: any) => {
      return (charCode: any) => returnFiteredFuncItem(charCode, s);
    },
    getFrameItem: (s: any) => {
      return (charCode: any) => returnFiteredFrameItem(charCode, s);
    },
    getFrameItems: (s:any) => 
    {
      return s.frameItems;
    },
    getMeasureItems:(s:any) => {
      return s.measureItems;
    },
    getDoorSurfaceItems:(s:any) => 
    {
      return s.doorSurfaceItems;
    },
    getExteriorAcessoriesItems: (s:any) => 
    {
      return s.exteriorAcessoriesItems;
    },
    getMountingMaterialItems: (s:any) => 
    {
      return s.mountingMaterialItems;
    },
    getBlindstockItems :(s:any) => 
    {
      return s.blindstockItems;
    },
    getFurtherInformationItems : (s:any) => 
    {
      return s.furtherInformationItems;
    },
    getBlankCharacteristic: (s: any) => {
      return s.noCharacteristic;
    },
    getAllInitialCharacteristicsAndValues: (s: any) => {
      return s.allInitialCharacteristicsAndValues;
    },
    getCharacteristicItemFromAllInitialCharacteristics: (s: any) => {
      return (characteristicCode: string) => getCharacteristic(characteristicCode, s);
    },
};

const actions = {
      storeUser(context : any , payload : any) {
        context.commit('storeUser', payload);
      },
      setProductId(context : any , payload : any)
      {
        context.commit('setProductId', payload);
      },
      setChargeId(context : any , payload : any)
      {
        context.commit('setChargeId', payload);
      },
      setCharacteristicState(context : any, payload : any) {
        context.commit('storeCharacteristicState', payload);
      },
      setMainNavActiveId(context : any, mainNavItemId : any) {
        context.commit('updateMainNavActiveId', mainNavItemId);
      },
      incrementMainNavActiveId(context : any, payload: any) {
        context.commit('incrementMainNavActiveId', payload);
      },
      setSubNavActiveId(context : any, payload : any) {
        context.commit('updateSubNavActiveId', payload);
      },
      updateDoorConfiguration(context: any, payload: any) {
        context.commit('updateDoorConfiguration', payload);
      },
      setMainNavigationItems(context: any, payload: any) {
        context.commit('updateMainNavigationItems', payload);
      },
      setArticleNumber(context: any, payload: any) {
        context.commit('updateArticleNumber', payload);
      },
      setFilteredCharacteristics(context: any, payload: any) {
        context.commit('updateFilteredCharacteristics', payload);
      },
      setAllInitialCharacteristicsAndValues(context: any, payload: any) {
        characteristicsService.getAllCharacteristics().then((response: any) => {
            context.commit('updateAllInitialCharacteristicsAndValues', response.data);
        });
      },
      // Action that calls each individual modules 'reset' mutation
      resetAllStates(context: any) {
        context.dispatch('modelSelectionModule/resetState');
      },

      resetState(context: any)
      {
        context.commit('resetState');
      },

      initConfiguratorModule(context : any, payload : any) {
        context.commit('initConfiguratorModule', payload);
      },

    resetMainNavigationItems(context : any) {
          context.commit('resetMainNavigationItems');
    },

      deleteAllStepsConfigurations(context : any)
      {
        const configuration = context.rootState.configuratorModule.doorConfiguration;
        configuration.ClearAllConfiguration();
      }
};

const mutations = {
      storeUser(state : any, payload : any) {
        state.user = payload;
      },
      setProductId(state : any, payload : any)
      {
        state.productId = payload;
      },
      setChargeId(state : any, payload : any)
      {
        state.chargeId = payload;
      },
      storeCharacteristicState(state : any, payload : any) {
        const storeEng = new StoreEngine(state.mainMenu);
        const menuChanged = storeEng.setCharacteristicState(
          state.mainNavActiveId, payload.settingKey, payload.property, payload.value);
        state.mainMenu = menuChanged;
      },
      updateMainNavActiveId(state : any, mainNavItemId : any) {
        state.mainNavActiveId = mainNavItemId;
      },
      incrementMainNavActiveId(state : any, payload: any) {
        let index = 0
        if (payload > -1)
          index = payload + 1
        state.mainNavActiveId = index
        state.subNavActiveId.mainNavActiveId = index
        state.subNavActiveId.subNavActiveId = 0
      },
      updateSubNavActiveId(state : any, payload : any) {
        state.subNavActiveId = payload;
      },
      updateDoorConfiguration(state: any, payload: any) {
        state.doorConfiguration = payload;
      },
      updateMainNavigationItems(s: any, payload: any) {
        s.mainNavigation = payload;
      },
      updateArticleNumber(s: any, payload: any) {
        s.ConfiguratorState.ArticleNumber = payload;
      },
      updateFilteredCharacteristics(s: any, payload: any) {
        s.filteredCharacteristics = payload;
      },
      updateAllInitialCharacteristicsAndValues(s: any, payload: any) {
        s.allInitialCharacteristicsAndValues = payload.characteristics;
      },
      initConfiguratorModule(state : any, payload : any){
         state.mainNavActiveId = payload.mainNavActiveId;
         state.doorConfiguration.configuration.table = payload.doorConfiguration.configuration.table;
         state.mainNavigation = payload.mainNavigation;
         state.ConfiguratorState.ArticleNumber = payload.ConfiguratorState.ArticleNumber;
         state.filteredCharacteristics = payload.filteredCharacteristics;
         state.allInitialCharacteristicsAndValues = payload.allInitialCharacteristicsAndValues;
      },

      resetMainNavigationItems(state : any) {
          state.mainNavActiveId = 0;
          state.doorConfiguration = DoorConfiguration.Instance;
          state.mainNavigation = navigation;
          state.ConfiguratorState.ArticleNumber = {
              ArticleNumber: '',
          };
      },

      resetState(s: any)
      {
        Object.assign(s, getDefaultState());
        console.log();
      }
};

const returnRegisteredCharacteristicObject = (code: string, configurationContext: number, s: any) => {
    const registeredCharacteristics = s.doorConfiguration.Get(configurationContext);
    let filteredCharacteristic;
  
    if (typeof registeredCharacteristics !== 'undefined') {
      filteredCharacteristic = registeredCharacteristics.filter(
          (characteristic: any) => characteristic.code === code)[0];
    }
  
    if (typeof filteredCharacteristic !== 'undefined') {
        return filteredCharacteristic;
    } else {
        return s.blankCharacteristic;
    }
  };


  const returnFiteredFrameItem = (charCode: any, s: any) => {
    const item = s.frameItems.filter((c: any) => c.code === charCode)[0];
    const ob = item;
    return ob;
  };

  const getCharacteristic = (code: string, s: any) => {
    const filteredCharacteristic = s.allInitialCharacteristicsAndValues.filter((characteristic: any) => characteristic.code === code)[0];
  
    if (typeof filteredCharacteristic !== 'undefined') {
        return filteredCharacteristic;
    } else {
        return s.blankCharacteristic;
    }
  };

  const returnFiteredFuncItem = (charCode: any, s: any) => {
    const item = s.functionsItems.filter((c: any) => c.code === charCode)[0];
    const ob = item;
    return ob;
  };
  
export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
};
